import type { AuthorityLevel } from "./types/enums.js";

export interface AuthorityConfig {
  label: string;
  /** Lucide icon name */
  icon: string;
  /** Custom icon name (dashboard only) */
  customIcon?:
    | "LegislationIcon"
    | "RegulationIcon"
    | "StandardIcon"
    | "CompanyPolicyIcon"
    | "GuidelineIcon"
    | "InformationalIcon";
  /** Sort order (0 = highest authority) */
  rank: number;
}

export const authorityConfig: Record<AuthorityLevel, AuthorityConfig> = {
  legislation: {
    label: "Legislation",
    icon: "Scale",
    customIcon: "LegislationIcon",
    rank: 0,
  },
  regulation: {
    label: "Regulation",
    icon: "Shield",
    customIcon: "RegulationIcon",
    rank: 1,
  },
  standard: {
    label: "Standard",
    icon: "CircleCheck",
    customIcon: "StandardIcon",
    rank: 2,
  },
  company_policy: {
    label: "Company policy",
    icon: "Building2",
    customIcon: "CompanyPolicyIcon",
    rank: 3,
  },
  guideline: {
    label: "Guideline",
    icon: "BookOpen",
    customIcon: "GuidelineIcon",
    rank: 4,
  },
  informational: {
    label: "Informational",
    icon: "Info",
    customIcon: "InformationalIcon",
    rank: 5,
  },
};

/** Authority levels sorted from highest to lowest authority */
export const authorityLevelsSorted: AuthorityLevel[] = [
  "legislation",
  "regulation",
  "standard",
  "company_policy",
  "guideline",
  "informational",
];
